import { UserRowRoleType } from '@modules/users/store/types';
import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import {
  PermissionModuleColumnCell,
  PermissionOperationColumnCell,
} from '../components/PermissionsTable/PermissionColumns';
import { PERMISSION_MODULE_LABEL_MAP } from '../constants';
import { PermissionTableModule } from '../types';

export const getPermissionsColumns = (
  isUserRolesEnabled: boolean,
): GridColDef[] => {
  const operationColumnMinWidth = isUserRolesEnabled ? 50 : 150;

  const getMemberAndViewerColumns = (): GridColDef[] => {
    return [
      {
        field: 'memberOperation',
        headerName: UserRowRoleType.Member,
        minWidth: operationColumnMinWidth,
        type: 'string',
        headerAlign: 'center',
        sortable: false,
        display: 'flex',
        renderCell: (params) => (
          <PermissionOperationColumnCell params={params} />
        ),
      },
      {
        field: 'viewerOperation',
        headerName: UserRowRoleType.Viewer,
        minWidth: operationColumnMinWidth,
        type: 'string',
        headerAlign: 'center',
        sortable: false,
        display: 'flex',
        renderCell: (params) => (
          <PermissionOperationColumnCell params={params} />
        ),
      },
    ];
  };

  return [
    {
      field: 'module',
      headerName: 'Module',
      renderHeader: () => {
        if (isUserRolesEnabled) {
          return (
            <Typography variant="body2" color="text.secondary">
              Available Actions on Enterpret
            </Typography>
          );
        }
      },
      minWidth: 200,
      flex: 1,
      type: 'string',
      sortingOrder: ['asc', 'desc'],
      display: 'flex',
      renderCell: (params) => <PermissionModuleColumnCell params={params} />,
      sortComparator: (
        value1: PermissionTableModule,
        value2: PermissionTableModule,
      ) => {
        const label1 = PERMISSION_MODULE_LABEL_MAP[value1] || '';
        const label2 = PERMISSION_MODULE_LABEL_MAP[value2] || '';

        return label1.localeCompare(label2);
      },
    },
    {
      field: 'adminOperation',
      headerName: UserRowRoleType.Admin,
      minWidth: operationColumnMinWidth,
      type: 'string',
      headerAlign: 'center',
      sortable: false,
      display: 'flex',
      renderCell: (params) => <PermissionOperationColumnCell params={params} />,
    },
    {
      field: 'editorOperation',
      headerName: UserRowRoleType.Editor,
      minWidth: operationColumnMinWidth,
      type: 'string',
      headerAlign: 'center',
      sortable: false,
      display: 'flex',
      renderCell: (params) => <PermissionOperationColumnCell params={params} />,
    },
    ...(isUserRolesEnabled ? getMemberAndViewerColumns() : []),
  ];
};
